import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select from "react-select"
import { AlertTriangle, EyeOff, Boxes, BarChart2,TrendingDown  } from 'lucide-react'; // lucide-react for icons
import CountUp from 'react-countup'; // at the top


const CurrentStockStatus = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n")
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [rowData, setRowData] = useState([]);
  const [currentSkuCode,setCurrentSkuCode] = useState("")
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState("")
  const [currentUploadedDate, setCurrentUploadedDate] = useState("")
  const [prevDate, setPrevDate] = useState("")
  const [ropCount, setRopCount] = useState(0)
  const [ropData, setRopData] =  useState([])
  const [safetyData, setSafetyData] =  useState([])
  const [safetyCount, setSafetyCount] =  useState([])

  const [currentDestinationId,setCurrentDestinationId] = useState("")
  const [editFormData, setEditFormData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });
  const [skuCode, setSkuCode] = useState({label : "ALL", value : ""});
  const [storeId, setStoreId] = useState({label : "ALL", value : ""}); 
  const [skuOptions,setSkuOptions] = useState([{label : "ALL", value : ""}])
  const [prevStoreId, setPrevStoreId] = useState({label : "ALL", value : ""})
  const [storeOptions,setStoreOptions] = useState([{label : "ALL", value : ""}])
  const [activeCounter, setActiveCounter] = useState("total"); // 'total' or 'rop'
  const gridApi = useRef(null); // Reference for the grid API
  const gridColumnApi = useRef(null); // Reference for the column API

  const columnWithDefs = [
    { headerName: "Destination Store ID", field: "destination_store_id", sortable: true, width : "197px", pinned : "left"},
    { headerName: "Destination Store Name", field: "destination_store_name", sortable: true ,width : "211px", pinned : "left"},

    { headerName: "SKU Code", field: "sku_code", sortable: true,flex : 1,width : "126px", pinned : "left"},
    {
    headerName: "Current Stock",
    field: "current_stock",
    sortable: true,
    width:"155px",
    flex: 1,
    cellStyle: params => {
      if (params.data?.reorder_flag === 1) {
        return { backgroundColor: '#ffe6e6' }; // light red
      }
      return null; // no style
    }
  },
    { headerName: "Existing Stock", field: "existing_stock", sortable: true,width:"158px",flex : 1 },
    { headerName: "Intransit Stock", field: "intransit_stock", sortable: true,width:"155px",flex : 1 },
    { headerName: "Previous Day Sales", field: "previous_day_sales", sortable: true,flex : 1,width : "183px"},
    { headerName: "Average Per Day Sale", field: "average_per_day_sale", sortable: true,width:"155px",flex : 1 },
    { headerName: "Re Order Point", field: "reorder_point", sortable: true,width:"155px",flex : 1 },
    { headerName: "Safety Stock", field: "safety_stock", sortable: true,width:"155px",flex : 1 },
    { 
    headerName: "Stock Status On", 
    field: "stock_status_created_for", 
    filter: "agDateColumnFilter", 
    valueFormatter: (params) => {
      const date = new Date(params.value);
      return date.toISOString().split('T')[0]; // Formats the date as YYYY-MM-DD
    },
    flex: 1
  },
  ];

  const resetFilters = () => {
    setSkuCode({label : "ALL", value : ""})
    setStoreId({label : storeOptions[0]["label"], value : ""})
  };  
  
  const resetFormData = () => {
   setEditFormData( {
        sku_code: "",
        sku_name: "",
        sku_category: "",
        unit_of_measure: "",
        minimum_order_quantity: "",
      })
      setDuplicatedEditData({
          sku_code: "",
          sku_name: "",
          sku_category: "",
          unit_of_measure: "",
          minimum_order_quantity: "",
      })
  }

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
  };




  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    // minWidth: "150px",
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  // onGridReady handler (for when the grid is initialized)
  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;

    // Auto-size columns when the grid is ready
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns && allColumns.length > 0) {
        const allColumnIds = allColumns.map(col => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  // onFirstDataRendered handler (for when the first data is rendered)
  const onFirstDataRendered = (params) => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns && allColumns.length > 0) {
        const allColumnIds = allColumns.map(col => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const getSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("inventory/getCurrentStockStatusData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const dataa = response.data.data
          const filteredData = dataa.filter(item => item?.reorder_flag === 1);
          const ropCount = filteredData.length
          const defaultData = response.data.data.filter(item => item.destination_store_id === storeId.value);
          setRopCount(ropCount)
          setRopData(filteredData)
          setRowData(defaultData);
          const formattedDate = response.data.date
          ? new Date(response.data.date).toISOString().split('T')[0]
          : '';
          resetFilters()
          setCurrentInvoiceDate(formattedDate);
          // setLoadshow("show-n");
          // setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n")
        }
      }
    }
    catch (error) {
      console.error("Error fetching Current Stock data:", error);
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
  }

    const resetgetSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("inventory/getCurrentStockStatusData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const dataa = response.data.data
          // console.log(storeOptions,"sds")
          const defaultData = response.data.data.filter(item => item.destination_store_id === storeOptions[0]["value"]);
          const filteredData = defaultData.filter(item => item?.reorder_flag === 1);
          const ropCount = filteredData.length
          setRopCount(ropCount)
          setRopData(filteredData)
          setRowData(defaultData);
          const formattedDate = response.data.date
          ? new Date(response.data.date).toISOString().split('T')[0]
          : '';
          resetFilters()
          setCurrentInvoiceDate(formattedDate);
          // setLoadshow("show-n");
          // setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n")
        }
      }
    }
    catch (error) {
      console.error("Error fetching Current Stock data:", error);
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
  }


const getSkuMasterDataByFilters = async () => {
    try{
      var params = {}
      params.stock_status_created_for = currentinvoiceDate ?  currentinvoiceDate : ""
      params.destination_store_id = storeId.value ?  storeId.value : ""
      params.sku_code = skuCode.value ?  skuCode.value : ""

      const response = await redirectURL.post("inventory/getCurrectStockstausByFilters", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
           const dataa = response.data.data
          const filteredData = dataa.filter(item => item?.reorder_flag === 1);
          const ropCount = filteredData.length
          setRopCount(ropCount)
          setRopData(filteredData)
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No Current Stock data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Current Stock data:", error);
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
}

const getSkuMasterDataByFilters2 = async (options) => {
    try{
      var params = {}
      params.stock_status_created_for = currentinvoiceDate ?  currentinvoiceDate : ""
      params.destination_store_id = storeId.value ?  storeId.value : ""
      params.sku_code = skuCode.value ?  skuCode.value : ""

      const response = await redirectURL.post("inventory/getCurrectStockstausByFilters", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
           const dataa = response.data.data
          const defaultData = response.data.data.filter(item => item.destination_store_id === options[0]["value"])
          const filteredData = defaultData.filter(item => item?.reorder_flag === 1);
          const safetyData = defaultData.filter(item => item?.safety_stock_flag === 1);
          const ropCount = filteredData.length
          const safetyCount = safetyData.length

          setRopCount(ropCount)

          setSafetyData(safetyData)
          setSafetyCount(safetyCount)

          setRopData(filteredData)
          setRowData(defaultData);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No Current Stock data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Current Stock data:", error);
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
}

const getDistinctStoreIdsByDate = async () => {
    try{
      const response = await redirectURL.post("inventory/getDistinctStoreIdsBYstockDate", {stock_status_created_for : currentinvoiceDate})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const distinctOptions = response.data.data
          // distinctOptions.unshift({label : "ALL", value : ""})
          setStoreId({label : distinctOptions[0]["label"], value :distinctOptions[0]["value"]})
          setStoreOptions(distinctOptions)
          getSkuMasterDataByFilters2(distinctOptions)
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Current Stock data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      // console.error("Error fetching Current Stock data:", error);
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
}

const getDistinctSkuCodes = async ()=> {
    try{

      var params = {
        stock_status_created_for : currentinvoiceDate,
        destination_store_id : storeId.value,
      }
      const response = await redirectURL.post("inventory/getDistinctSkuCodesForStockStatus", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {

          const distinctOptions = response.data.data.map(item => ({label : item, value : item}))
          distinctOptions.unshift({label : "ALL", value : ""})
          setSkuCode({label : "ALL", value : ""})
          setSkuOptions(distinctOptions)

          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
           setLoadshow("show-n");
           setOverlayBlock("show-n");
          // setBasicTitle("No Current Stock data found");
          // setBasicType("info");
          // setShow(true);
        }
      }
    }
    catch (error) {
      // console.error("Error fetching Current Stock data:", error);
        setLoadshow("show-n");
          setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch Current Stock data");
      setBasicType("error");
      setShow(true);
    }
}

const getMainData = async () => {
    setLoadshow("show-m");  
    setOverlayBlock("show-m");
    await getSkuMasterData()
    // setLoadshow("show-n");  
    // setOverlayBlock("show-n");
}

const onResetData = async () => {
    setLoadshow("show-m");  
    setOverlayBlock("show-m");
    await resetgetSkuMasterData()
    setLoadshow("show-n");  
    setOverlayBlock("show-n");
}



  useEffect(() => {
    const getData = async () => {
      if(!rowData.length > 0) {
        await getMainData()
      }
    }
    getData()
  }, []);

  useEffect(() => {
    const getData = async () => {
      
      if (prevDate !== currentinvoiceDate) {
        // setLoadshow("show-m");  
        // setOverlayBlock("show-m");
        await getDistinctStoreIdsByDate()
        setLoadshow("show-n");  
        setOverlayBlock("show-n");
      }
  
      }

    getData()
  }, [currentinvoiceDate])


  useEffect(() => {
    const getData = async () => {
     
      if (prevDate !== currentinvoiceDate && prevStoreId.value !== storeId.value) {
      //    setLoadshow("show-m");  
      // setOverlayBlock("show-m");
          await getDistinctSkuCodes()
          setLoadshow("show-n");  
      setOverlayBlock("show-n");
      }
      
      }

    getData()
  }, [currentinvoiceDate , storeId.value])


const closeAlert = () => {
 const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }

  setUploadedFileData([]);
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setShowDeletePopup(false)
  setSliderOpen(false)
  setCurrentUploadedDate("")
  // resetFormData();
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Destination Store Id",
        "SKU Code",
        "Sale Quantity",
        "Destination Store Name",
        // "Invoice Date"
      ],
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_historic_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

        const mapping = {
          "Destination Store Id": "destination_store_id",
          "Destination Store Name" : "destination_store_name",
          "SKU Code": "sku_code",
          "Sale Quantity": "sale_quantity",
        };

        function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

        // transform
        const result = parsedData.map(item => {
          const newItem = {};
          for (const key in item) {
            if (mapping[key]) {
              // if in mapping use mapped version
              newItem[mapping[key]] = item[key];
            } else {
              // if not in mapping, convert key to snake_case
              newItem[toSnakeCase(key)] = item[key];
            }
          }
          return newItem;
        });


      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };
  
  const onClickingFileSubmit = async () => {
    const params = { date : currentUploadedDate, masterData: uploadedFileData };
      try {
        const response = await redirectURL.post(
          "inventory/storeHistoricSalesData",
          params
        );
       
        if (response.data.status === "success") {
          await getSkuMasterData();
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");
        } else {
          setLoadshow("show-n");
           setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");
        }
        
      } catch (error) {
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to upload data");
      }
  };


  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25"); 
    setSliderTitle("Upload Destinationm Data");
    setOverlyBlock("show-m");
  };

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {  
      sku_code: editFormData.sku_code,
      sku_name: editFormData.sku_name,
      sku_category: editFormData.sku_category,
      unit_of_measure: editFormData.unit_of_measure,
      minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
    };  

    const isNeedtoUpdate = Object.keys(editFormData).filter(
    (key) => editFormData[key] !== duplicatedEditData[key] && editFormData[key] !== ""
    )

    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to stock data or empty keys");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/updateSkuMasterData",
        params
      );

      
      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Current Stock Data Updated Successfully");
        // Update the rowData with the new data
        const updatedRowData = rowData.map((row) =>
          row.sku_code === editFormData.sku_code ? editFormData : row
        );
        setRowData(updatedRowData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update Current Stock data");
      }
      
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Current Stock data");
    }
  }

  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {
      sku_code: editFormData.sku_code,
      sku_name: editFormData.sku_name,
      sku_category: editFormData.sku_category,
      unit_of_measure: editFormData.unit_of_measure,
      minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
    };

    const validationErrors = Object.keys(params).filter((key) => {
      const value = params[key];
      // Apply trim only for string fields
      if (typeof value === "string") {
        return !value || value.trim() === "";
      } else if (value === undefined || value === null || value === "") {
        return true;
      }
      return false;
    });

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    const validSkuCode = /^[a-zA-Z0-9_-]+$/.test(params.sku_code);  
    const validatemoq = /^[0-9]+$/.test(params.minimum_order_quantity);
    if (!validatemoq) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Minimum Order Quantity must be a valid number");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    if (!validSkuCode) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Current Stock Code can only contain letters, numbers, underscores, and hyphens");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/addSkuProduct",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Current Stock Product Added Successfully");
        setRowData((prevRowData) => [...prevRowData, params]);

      } else {
         setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to add Current Stock Product");
      }
     
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to add Current Stock Product");
    }
  }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { sku_code: selectedRow.sku_code };
    try { 
      const response = await redirectURL.post(
        "masters/deleteSKU",
        params
      );
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Current Stock Product Deleted Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Current Stock Product");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Current Stock Product");
    }


  };

  const onClickDeletePopupCancelBtn = () => {
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };

  const setfiltersData = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getSkuMasterDataByFilters()
    setLoadshow("show-n")
    setOverlayBlock("show-n")
  }

  let finalData = activeCounter === "rop" ? ropData : activeCounter === "safety" ? safetyData : rowData

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "0.9rem",fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Current Stock Status</h1>
          </div>
        <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-8 row ">
              <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column"}}>
               <label
                  // htmlFor="invoiceDate"
                  style={{ fontSize: "13px", fontWeight: "400"}}
                >
                  Stock Status On:
                </label>
                <input
                  type="date"
                  id="invoiceDate"
                  value={currentinvoiceDate}
                  onChange={(e) => {setPrevDate(currentinvoiceDate); setCurrentInvoiceDate(e.target.value)}}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('invoiceDate').showPicker?.()}
                />
              </div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store ID:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={(selectedOption) => {setPrevStoreId(storeId); setStoreId(selectedOption)}}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label  style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                    value={skuCode}
                    onChange={(selectedOption) => setSkuCode(selectedOption)}
                    options={skuOptions}
                    styles={selectStyles}
                  />
              </div>

            <div className="ml-4 mt-2" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
              <button 
                type="button" 
                onClick={(e) =>{e.preventDefault(); setfiltersData()}}
                style={{
                backgroundColor: "#93385D",
                color: "#fff",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "none",
                cursor: "pointer"
              }}>Apply</button>
              <button 
                onClick={(e)=> {e.preventDefault(); onResetData()}}
                type="button" 
                style={{
                backgroundColor: "#fff",
                color: "#000",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "1px solid #d9d9d9",
                cursor: "pointer"
              }}>Reset</button>
            </div>
             </div>
              <div className="col-sm-4 d-flex flex-row justify-content-end p-0">
                {/* Total Counter */}
                <div
                  style={{
                    width: "100%",
                    background: activeCounter === "total" ? "#e6f7ff" : "#fafafa",
                    borderRadius: 8,
                    cursor: "pointer",
                    marginRight: 8,
                    border: activeCounter === "total" ? "2px solid #1890ff" : "1px solid #d9d9d9",
                    padding: '10px 0',
                  }}
                  onClick={() => setActiveCounter("total")}
                  className="rounded shadow-sm flex flex-col items-center justify-center text-center"
                >
                  <div className="flex items-center gap-2 mb-4 text-blue-500">
                    <Boxes size={16} style={{ color: "#1890ff", marginRight: "6px" }} />
                    <span className="text-xs font-semibold text-gray-600">Total SKUs</span>
                  </div>
                  <div className="text-blue-600 text-2xl font-bold mb-1">
                    <CountUp end={rowData.length} duration={1.5} separator="," />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    background: activeCounter === "rop" ? "#ffe6e6" : "#fafafa",
                    borderRadius: 8,
                    cursor: "pointer",
                    marginRight: 8,
                    border: activeCounter === "rop" ? "2px solid #ff4d4f" : "1px solid #d9d9d9",
                    padding: '10px 0',
                  }}
                  onClick={() => setActiveCounter("rop")}
                  className="rounded shadow-sm flex flex-col items-center justify-center text-center"
                >
                  <div className="flex items-center gap-2 mb-4 text-blue-500">
                    <AlertTriangle size={16} style={{ color: "red", marginRight: "6px" }} />
                    <span className="text-xs font-semibold text-gray-600">Rop Reached SKUs</span>
                  </div>
                  <div className="text-red-600 text-2xl font-bold mb-1">
                    <CountUp end={ropData.length} duration={1.5} separator="," />
                  </div>
                </div>

              <div
                  style={{
                    width: "100%",
                    background: activeCounter === "safety" ? "#eaf5e4" : "#fafafa",
                    borderRadius: 8,
                    cursor: "pointer",
                    marginRight: 8,
                    border: activeCounter === "safety" ? "2px solid #aecaa0ff" : "1px solid #d9d9d9",
                    padding: '10px 0',
                  }}
                  onClick={() => setActiveCounter("safety")}
                  className="rounded shadow-sm flex flex-col items-center justify-center text-center"
                >
                  <div className="flex items-center gap-2 mb-4 text-blue-500">
                    <TrendingDown  size={16} style={{ color: "green", marginRight: "6px" }} />
                    <span className="text-xs font-semibold text-gray-600">Safety Reached SKUs</span>
                  </div>
                  <div className="text-red-600 text-2xl font-bold mb-1">
                    <CountUp end={safetyData.length} duration={1.5} separator="," />
                  </div>
                </div>
              </div>
         </form>
         
    
              {/* <div className="col-sm-12 mt-2 text-right p-0">
                    <button 
                      onClick={onClickUploadSkuMasterData}
                      className="mr-2 add-button upload-add-button"
                      >
                      <MdOutlineFileUpload style={{color : "#93385D", fontSize :"18px"}}/>
                    {" Upload Sales Data"}
                  </button>
              </div> */}
            <div className="col-sm-12 p-0 pl-2 mt-6">
            
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={finalData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressHorizontalScroll={false} // allow scroll
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
          
        </div>

      {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => {e.preventDefault() ; onClickingFileSubmit()}}
            >
             <div className="mb-1" style={{ display: "flex", flexDirection: "column"}}>
               <label
                  htmlFor="uploadDate"
                  style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}
                >
                  Date:
                </label>
                <input
                  type="date"
                  id="uploadDate"
                  value={currentUploadedDate}
                  onChange={(e) => {setCurrentUploadedDate(e.target.value)}}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('uploadDate').showPicker?.()}
                  required
                />
              </div>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  className="btn btn-info"
                  onClick={downloadExcelTemplate}
                >
                  {"Download Sample Template"}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>
             
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
              
                >
                  {"Submit"}
                </button>
              </div>
            </form>
          </div>
      )}
      {sliderType === 3 && (
        <form style={{ padding: "20px" }} 
          onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onClickingUpdateSkuData();
          }}
          >
          <div className="form-group">
              <label
                htmlFor="sku_code"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "5px",
                  display: "block",
                }}
              >
                Product Code <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sku_code"
                name="sku_code"
                value={editFormData.sku_code}
                onChange={(e) =>
                  setEditFormData({ ...editFormData, sku_code: e.target.value })
                }
                placeholder="Enter Current Stock Code"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem",
                  backgroundColor: "#f9f9f9",
                  cursor: "not-allowed",
                }}
                disabled  // ⬅️ this makes the field read-only
                required
              />
          </div>

          <div className="form-group">
            <label htmlFor="sku_name" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Product Name <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="sku_name"
              name="sku_name"
              value={editFormData.sku_name}
              onChange={(e) => setEditFormData({ ...editFormData, sku_name: e.target.value })}
              placeholder="Enter Current Stock Name"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="sku_category" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Product Category <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="sku_category"
              name="sku_category"
              value={editFormData.sku_category}
              onChange={(e) => setEditFormData({ ...editFormData, sku_category: e.target.value })}
              placeholder="Enter Product Category"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
            </div>
            <div className="form-group">
            <label htmlFor="unit_of_measure" style={{   
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Unit Of Measure <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="unit_of_measure"  
              name="unit_of_measure"
              value={editFormData.unit_of_measure}
              onChange={(e) => setEditFormData({ ...editFormData, unit_of_measure: e.target.value })}
              placeholder="Enter Unit Of Measure"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="minimum_order_quantity" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Minimum Order Quantity <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="minimum_order_quantity"
              name="minimum_order_quantity"
              value={editFormData.minimum_order_quantity}
              onChange={(e) => setEditFormData({ ...editFormData, minimum_order_quantity: e.target.value })}
              placeholder="Enter Minimum Order Quantity"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div style={addButtonContainerStyle}>
            <button
              type="submit"
              className="btn btn-success"
              // style={addButtonStyle}
              
            >
              Update
            </button> 
          </div>
    </form>
    )}
      </div>
           {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.sku_code : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "7px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '1px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 'normal',   // <-- make the text not bold
      color: '#333', 
      fontSize : "12px"         // optional: adjust color
    }),
    option: (base, state) => ({
      ...base,
      fontSize : "13px",
      fontWeight: state.isSelected ? 'normal' : 'normal', // make options also normal if you wish
    })
  }

export default CurrentStockStatus;
